/* ============================================================
   BLOCCO STUDIO — bs-main.js
   Caricato deferred. GSAP deve essere già caricato via CDN.
   ============================================================ */

window.addEventListener('load', () => { BSInit(); });

function BSInit() {
  // Graceful fallback se GSAP non carica (es. offline)
  if (typeof gsap === 'undefined') {
    document.body.classList.remove('loading');
    const preloader = document.getElementById('bs-preloader');
    if (preloader) preloader.style.display = 'none';
    document.querySelectorAll('.reveal').forEach(el => {
      el.style.opacity = '1';
      el.style.transform = 'none';
    });
    return;
  }

  gsap.registerPlugin(ScrollTrigger);

  // ---- PRELOADER ----
  const preloader = document.getElementById('bs-preloader');
  if (preloader) {
    const bar      = document.getElementById('bsPreloaderBar');
    const logo     = preloader.querySelector('.preloader-logo');
    const progress = preloader.querySelector('.preloader-progress');

    const tl = gsap.timeline({
      onComplete: () => {
        document.body.classList.remove('loading');
        BSHeroAnim();
      }
    });

    tl.to(logo,     { opacity: 1, y: 0, duration: 0.7, ease: 'power3.out' }, 0.1)
      .to(progress, { opacity: 1, duration: 0.3 }, 0.5);

    let pct = 0;
    const fakeProgress = setInterval(() => {
      pct += Math.random() * 15 + 5;
      if (pct >= 100) { pct = 100; clearInterval(fakeProgress); }
      if (bar) bar.style.width = pct + '%';
    }, 100);

    tl.to(preloader, { yPercent: -100, duration: 0.9, ease: 'power4.inOut', delay: 1.2 });
  } else {
    // Nessun preloader in pagine diverse dalla home (es. case study)
    document.body.classList.remove('loading');
    BSHeroAnim();
  }

  // ---- HERO ANIMATION ----
  function BSHeroAnim() {
    const words   = gsap.utils.toArray('.hero-title .word');
    const eyebrow = document.querySelector('.hero-eyebrow');
    const bottom  = document.querySelector('.hero-bottom');
    if (!words.length) return;

    const heroTl = gsap.timeline({ defaults: { ease: 'power4.out' } });
    if (eyebrow) heroTl.to(eyebrow, { opacity: 1, y: 0, duration: 0.6 });
    heroTl.to(words, { y: 0, duration: 0.9, stagger: 0.06 }, eyebrow ? '-=0.3' : 0);
    if (bottom)  heroTl.to(bottom, { opacity: 1, y: 0, duration: 0.7 }, '-=0.4');
  }

  // ---- SCROLL REVEALS ----
  ScrollTrigger.batch('.reveal', {
    onEnter: batch => gsap.to(batch, {
      opacity: 1, y: 0, duration: 0.8, stagger: 0.12, ease: 'power3.out'
    }),
    start: 'top 88%',
    once: true,
  });

  // ---- NAV SCROLL STATE ----
  const nav = document.getElementById('bs-nav');
  if (nav) {
    ScrollTrigger.create({
      start: 'top -80px',
      onUpdate: self => nav.classList.toggle('scrolled', self.scroll() > 80)
    });
  }
}

// ---- CUSTOM CURSOR (solo desktop) ----
if (!('ontouchstart' in window)) {
  const cursor     = document.getElementById('bs-cursor');
  const cursorRing = document.getElementById('bs-cursor-ring');

  if (cursor && cursorRing) {
    let mouseX = 0, mouseY = 0, ringX = 0, ringY = 0;

    document.addEventListener('mousemove', e => {
      mouseX = e.clientX;
      mouseY = e.clientY;
      cursor.style.transform = 'translate(' + mouseX + 'px,' + mouseY + 'px)';
    });

    (function animateRing() {
      ringX += (mouseX - ringX) * 0.12;
      ringY += (mouseY - ringY) * 0.12;
      cursorRing.style.transform = 'translate(' + ringX + 'px,' + ringY + 'px)';
      requestAnimationFrame(animateRing);
    })();

    const hoverTargets = 'a, button, .project-card, .btn-cta, .client-cell, .testimonial-card';
    document.querySelectorAll(hoverTargets).forEach(el => {
      el.addEventListener('mouseenter', () => {
        cursor.classList.add('hovered');
        cursorRing.classList.add('hovered');
      });
      el.addEventListener('mouseleave', () => {
        cursor.classList.remove('hovered');
        cursorRing.classList.remove('hovered');
      });
    });
  }
} else {
  const c  = document.getElementById('bs-cursor');
  const cr = document.getElementById('bs-cursor-ring');
  if (c)  c.style.display  = 'none';
  if (cr) cr.style.display = 'none';
}

// ---- MOBILE MENU ----
const hamburger  = document.getElementById('bs-hamburger');
const mobileMenu = document.getElementById('bs-mobile-menu');

if (hamburger && mobileMenu) {
  hamburger.addEventListener('click', () => {
    const isOpen = mobileMenu.classList.toggle('open');
    hamburger.classList.toggle('open', isOpen);
    hamburger.setAttribute('aria-expanded', isOpen);
    document.body.style.overflow = isOpen ? 'hidden' : '';
  });
  document.querySelectorAll('.bs-mobile-link').forEach(link => {
    link.addEventListener('click', () => {
      mobileMenu.classList.remove('open');
      hamburger.classList.remove('open');
      hamburger.setAttribute('aria-expanded', false);
      document.body.style.overflow = '';
    });
  });
}

// ---- PARALLAX SULLE CARD PROGETTO ----
if (!('ontouchstart' in window)) {
  document.querySelectorAll('.project-card').forEach(card => {
    card.addEventListener('mousemove', e => {
      const rect = card.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width  - 0.5) * 12;
      const y = ((e.clientY - rect.top)  / rect.height - 0.5) * 8;
      const visual = card.querySelector('.card-visual');
      if (visual) visual.style.transform = 'scale(1.04) translate(' + (x * 0.4) + 'px,' + (y * 0.4) + 'px)';
    });
    card.addEventListener('mouseleave', () => {
      const visual = card.querySelector('.card-visual');
      if (visual) visual.style.transform = '';
    });
  });
}

// ---- CONTACT FORM ----
const contactForm   = document.getElementById('bs-contact-form');
const formSuccess   = document.getElementById('bs-form-success');

if (contactForm && formSuccess) {
  contactForm.addEventListener('submit', e => {
    e.preventDefault();
    const name  = contactForm.querySelector('[name="contact[name]"]')?.value.trim();
    const email = contactForm.querySelector('[name="contact[email]"]')?.value.trim();
    if (!name || !email) return;
    // In produzione: Shopify invia a /contact con method POST e action="/contact"
    // Per ora mostriamo il success state
    contactForm.style.display = 'none';
    formSuccess.classList.add('show');
  });
}
